'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrowLeft = require('@atlaskit/icon/glyph/arrow-left');

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _arrowRight = require('@atlaskit/icon/glyph/arrow-right');

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _theme = require('@atlaskit/theme');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../util');

var _Btn = require('./Btn');

var _Btn2 = _interopRequireDefault(_Btn);

var _Heading = require('../styled/Heading');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  return _react2.default.createElement(
    _Heading.Heading,
    { 'aria-hidden': 'true' },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _Btn2.default,
        { onClick: props.handleClickPrev },
        _react2.default.createElement(_arrowLeft2.default, {
          label: 'Last month',
          size: 'medium',
          primaryColor: _theme.colors.N80
        })
      )
    ),
    _react2.default.createElement(
      _Heading.MonthAndYear,
      null,
      (0, _util.getMonthName)(props.month) + ' ' + props.year
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _Btn2.default,
        { onClick: props.handleClickNext },
        _react2.default.createElement(_arrowRight2.default, {
          label: 'Next month',
          size: 'medium',
          primaryColor: _theme.colors.N80
        })
      )
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/calendar/dist/cjs/components/Heading.js
// module id = 467
// module chunks = 0